let sliderSplideInit;

const addPaginationThumbnails = (element) => {
    const slides = element.querySelectorAll(
        '.splide__slide:not(.splide__slide--clone)'
    );
    const buttons = element.querySelectorAll('.splide__pagination button');

    buttons.forEach((button, index) => {
        const sourceImage = slides[index]?.querySelector('picture img');
        const source =
            sourceImage?.getAttribute('data-src') ||
            sourceImage?.getAttribute('src');

        if (!source) {
            return;
        }

        const thumbnail = document.createElement('img');
        thumbnail.src = source;
        thumbnail.alt = '';
        thumbnail.setAttribute('aria-hidden', 'true');
        button.replaceChildren(thumbnail);
    });
};

document.addEventListener('DOMContentLoaded', () => {
    if (!sliderSplideInit) {
        document.querySelectorAll('.slider-splide').forEach((element) => {
            // eslint-disable-next-line no-undef
            const slider = new Splide(element);

            if (element.hasAttribute('data-thumbnail-pagination')) {
                slider.on('mounted', () => addPaginationThumbnails(element));
            }

            slider.mount();
        });
        sliderSplideInit = true;
    }
});
